import React from 'react';

function MyIssues({
  issues,
  loading,
  error,
  selectedIssue,
  onSelectIssue,
  getStatusColor,
  getPriorityIcon
}) {
  // Format date for display
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const now = new Date();
    const diff = now - date;
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));

    if (days === 0) {
      const hours = Math.floor(diff / (1000 * 60 * 60));
      if (hours === 0) {
        const mins = Math.floor(diff / (1000 * 60));
        return mins <= 1 ? 'Just now' : `${mins}m ago`;
      }
      return `${hours}h ago`;
    }
    if (days === 1) return 'Yesterday';
    if (days < 7) return `${days}d ago`;

    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
    });
  };

  if (loading) {
    return (
      <div className="issues-loading">
        <div className="spinner"></div>
        <p>Loading issues...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="issues-error">
        <p>{error}</p>
      </div>
    );
  }

  if (issues.length === 0) {
    return (
      <div className="issues-empty">
        <p>No issues found</p>
      </div>
    );
  }

  return (
    <div className="issues-list">
      {issues.map(issue => {
        const priority = getPriorityIcon(issue.priority?.name);

        return (
          <div
            key={issue.id}
            className={`issue-card ${selectedIssue === issue.id ? 'selected' : ''} ${issue._unread ? 'unread' : ''}`}
            onClick={() => onSelectIssue(issue.id)}
          >
            {issue._unread && <span className="unread-dot"></span>}

            <div className="issue-card-header">
              <span className="issue-id">#{issue.id}</span>
              <span
                className="issue-status"
                style={{ backgroundColor: getStatusColor(issue.status?.name) }}
              >
                {issue.status?.name}
              </span>
              {priority.icon && (
                <span className="issue-priority" style={{ color: priority.color }}>
                  {priority.icon}
                </span>
              )}
            </div>

            <div className="issue-card-subject">
              {issue.subject}
            </div>

            <div className="issue-card-meta">
              <span className="issue-project">{issue.project?.name}</span>
              <span className="issue-updated">{formatDate(issue.updated_on)}</span>
            </div>

            <div className="issue-card-footer">
              {issue.assigned_to ? (
                <span className="issue-assignee">
                  <span className="assignee-avatar">
                    {issue.assigned_to.name?.charAt(0).toUpperCase()}
                  </span>
                  {issue.assigned_to.name}
                </span>
              ) : (
                <span className="issue-unassigned">Unassigned</span>
              )}

              {issue._source && (
                <span className={`issue-source source-${issue._source}`}>
                  {issue._source === 'assigned' && 'Assigned'}
                  {issue._source === 'created' && 'Author'}
                  {issue._source === 'watching' && 'Watching'}
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default MyIssues;
